import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from 'react-hot-toast';
import { LOGOUT } from "./auth";  

const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify({}),
      redirect: "follow"
    };

    try {
      const response = await fetch("https://backend.pmc-group.uk/api/logout", requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Clear local storage or any other necessary cleanup
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      // Dispatch the Redux logout action
      dispatch({
        type: LOGOUT,
      });

      toast.success("Logout successful!");
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error);
      toast.error("Logout failed. Please try again.");
    }
  };

  return handleLogout;
};


export default useLogout;

